export interface OhsMobileMessageTypes {
  action: 'go_back' | 'submit';
  success?: boolean;
  data?: any;
}

const sendMobileMessage = (message: OhsMobileMessageTypes) => {
  try {
    window.webkit?.messageHandlers?.iOSHandler?.postMessage?.(message);
  } catch (error) {
    console.error('Error sending message to iOS handler:', error);
  }
  try {
    window.AndroidHandler?.postMessage?.(JSON.stringify(message));
  } catch (error) {
    console.error('Error sending message to Android handler:', error);
  }
};

export default {
  sendMobileMessage,
};
